/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaEsercenteListFilter { 
    tipologia?: TipologiaPratica;
    q?: string;
    /**
     * Partecipazione all\'adesione dell\'esercente: APERTA = il bando accetta adesioni adesso (stesso criterio di puo_partecipare), CHIUSA = non le accetta. Assente = tutti.
     */
    partecipazione?: TipoPraticaEsercenteListFilterPartecipazioneEnum;
}
export enum TipoPraticaEsercenteListFilterPartecipazioneEnum {
    APERTA = 'APERTA',
    CHIUSA = 'CHIUSA'
};



